import { forwardRef } from "react";
import { renderTypography, useTypography, useTypographyStyles, } from "./styles";
export const Text = forwardRef((props, ref) => {
    const state = useTypography({ as: "p", block: true, ...props }, ref);
    useTypographyStyles(state);
    return renderTypography(state);
});
Text.displayName = "Text";
export default Text;
